import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Button } from "@/shared/ui/button";
import { Mail, Shield } from "lucide-react";
import { useTranslation } from "@/shared/i18n";

export default function DataDeletionPage() {
  const { t } = useTranslation('lgpd');
  return (
    <div className="min-h-screen bg-[#1A1A1A] text-white py-8 px-4">
      <div className="max-w-2xl mx-auto space-y-6">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-2">
            <Shield className="h-8 w-8 text-blue-400" />
            <h1 className="text-2xl font-bold">
              {t('title')}
            </h1>
          </div>
          <p className="text-gray-300">
            {t('subtitle')}
          </p>
        </div>

        {/* Como Solicitar */}
        <Card className="bg-[#2A2A2A] border-gray-700">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-white">
              <Mail className="h-5 w-5 text-blue-400" />
              {t('howToRequest')}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-gray-300">
            <div className="space-y-3">
              <div>
                <h3 className="font-semibold text-white mb-1">{t('step1Title')}</h3>
                <p className="text-sm">
                  {t('step1Description')}
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-1">{t('step2Title')}</h3>
                <p className="text-sm">
                  {t('step2Description')}
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-1">{t('step3Title')}</h3>
                <p className="text-sm">
                  {t('step3Description')} <strong className="text-blue-400">{t('step3Email')}</strong>
                </p>
                <p className="text-xs text-gray-400 mt-1">
                  {t('step3Subject')}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Prazos */}
        <Card className="bg-[#2A2A2A] border-gray-700">
          <CardHeader>
            <CardTitle className="text-white">{t('deadlines')}</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-300">
            <ul className="space-y-2 text-sm">
              <li>• <strong>{t('deadlineConfirmation')}</strong></li>
              <li>• <strong>{t('deadlineProcessing')}</strong></li>
              <li>• <strong>{t('deadlineComplete')}</strong></li>
            </ul>
          </CardContent>
        </Card>

        {/* Dados */}
        <Card className="bg-[#2A2A2A] border-gray-700">
          <CardHeader>
            <CardTitle className="text-white">{t('data')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-gray-300">
            <div>
              <h4 className="font-semibold text-green-400 mb-2">{t('willBeDeleted')}</h4>
              <ul className="text-sm space-y-1">
                <li>• {t('willBeDeleted1')}</li>
                <li>• {t('willBeDeleted2')}</li>
                <li>• {t('willBeDeleted3')}</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-orange-400 mb-2">{t('mayBeKept')}</h4>
              <ul className="text-sm space-y-1">
                <li>• {t('mayBeKept1')}</li>
                <li>• {t('mayBeKept2')}</li>
              </ul>
            </div>
          </CardContent>
        </Card>

        {/* Call to Action */}
        <div className="text-center">
          <Button 
            size="lg" 
            className="bg-blue-600 hover:bg-blue-700 text-white"
            onClick={() => window.open(`mailto:${t('step3Email')}?subject=${t('step3Subject')}`, '_blank')}
          >
            <Mail className="h-4 w-4 mr-2" />
            {t('sendRequest')}
          </Button>
        </div>
      </div>
    </div>
  );
}
